import { useEffect, useState } from 'react'

import { preserveParamsOnHashNav } from '../utils/preserve-params-on-hash-nav'

export const usePreservedHref = (
  href: string | undefined,
  preserveQueryParams: boolean | null | undefined,
): string | undefined => {
  const [preservedHref, setPreservedHref] = useState(href)

  useEffect(() => {
    if (href && preserveQueryParams) {
      setPreservedHref(preserveParamsOnHashNav(href))
    }
  }, [href, preserveQueryParams])

  return preservedHref
}
